import React from 'react'

/** Dieselbe Schnittstelle wie ein lucide-Icon, soweit die Auswahl-Befehle sie nutzen. */
export interface SelectionCommandIconProps {
  size?: number
  strokeWidth?: number
  className?: string
}

const LucideFrame: React.FC<SelectionCommandIconProps & { block: string; viewBox?: string; children: React.ReactNode }> = ({
  block, viewBox = '0 0 24 24', size = 24, strokeWidth = 2, className, children,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={viewBox}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={[block, className].filter(Boolean).join(' ')}
    aria-hidden="true"
  >
    {children}
  </svg>
)

/*
  **Nachbauten von lucide** (0.577) für die Befehle der Auswahl-Pille, deren Teile sich beim Überfahren
  einzeln bewegen (#315, `_toolbarIconMotion.scss`). Gleiche Pfade, gleiche Reihenfolge, nur mit
  Teil-Klassen — lucide lässt keine Teile ansprechen. Bewegt sich das ganze Zeichen (Wieder öffnen,
  Favorit), bleibt es bei lucide.
*/

/** lucide `CircleCheck`. Der Haken zeichnet sich (`pathLength` 1 für den Strich-Versatz). */
export const SelectionCompleteIcon: React.FC<SelectionCommandIconProps> = (props) => (
  <LucideFrame block="selection-complete-icon" {...props}>
    <circle className="selection-complete-icon__circle" cx="12" cy="12" r="10" />
    <path className="selection-complete-icon__check" d="m9 12 2 2 4-4" pathLength={1} />
  </LucideFrame>
)

/**
 * lucide `FolderInput`. lucide zeichnet den Ordner von y 3 bis 20 — eine halbe Einheit über der Mitte;
 * der Ausschnitt rückt ihn zurück.
 */
export const SelectionMoveIcon: React.FC<SelectionCommandIconProps> = (props) => (
  <LucideFrame block="selection-move-icon" viewBox="0 -0.5 24 24" {...props}>
    <path
      className="selection-move-icon__folder"
      d="M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1"
    />
    <g className="selection-move-icon__arrow">
      <path d="M2 13h10" />
      <path d="m9 16 3-3-3-3" />
    </g>
  </LucideFrame>
)

/** lucide `Trash2`. */
export const SelectionDeleteIcon: React.FC<SelectionCommandIconProps> = (props) => (
  <LucideFrame block="selection-delete-icon" {...props}>
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <g className="selection-delete-icon__lid">
      <path d="M3 6h18" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </g>
  </LucideFrame>
)

/** lucide `StarOff`. Der Strich zieht sich nach (`pathLength` 1 für den Strich-Versatz). */
export const SelectionUnfavoriteIcon: React.FC<SelectionCommandIconProps> = (props) => (
  <LucideFrame block="selection-unfavorite-icon" {...props}>
    <g className="selection-unfavorite-icon__star">
      <path d="m10.344 4.688 1.181-2.393a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.237 3.152" />
      <path d="m17.945 17.945.43 2.505a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a8 8 0 0 0 .4-.099" />
    </g>
    <path className="selection-unfavorite-icon__slash" d="m2 2 20 20" pathLength={1} />
  </LucideFrame>
)

/** lucide `Ellipsis`. */
export const SelectionMoreIcon: React.FC<SelectionCommandIconProps> = (props) => (
  <LucideFrame block="selection-more-icon" {...props}>
    <circle className="selection-more-icon__dot selection-more-icon__dot--middle" cx="12" cy="12" r="1" />
    <circle className="selection-more-icon__dot selection-more-icon__dot--right" cx="19" cy="12" r="1" />
    <circle className="selection-more-icon__dot selection-more-icon__dot--left" cx="5" cy="12" r="1" />
  </LucideFrame>
)
